import { render, staticRenderFns } from "./WarehouseInOut.vue?vue&type=template&id=f96d4060"
import script from "./WarehouseInOut.vue?vue&type=script&lang=js"
export * from "./WarehouseInOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports